export enum EventSlug {
  OFFER_LINK_CLICKED = 'offer_link_clicked',
  VIEW_ENTERED = 'view_entered',
  VIEW_EXITED = 'view_exited',
  INFO_VIEW_ENTERED = 'info_view_entered',
  INFO_VIEW_EXITED = 'info_view_exited',
  LIKED = 'liked',
  UNLIKED = 'unliked',
  ACTIVATED = 'activated',
  DEACTIVATED = 'deactivated',
  OFFER_VIEWED = 'offer_viewed',
  OFFER_IMPRESSION = 'offer_impression',
  PASS_VIEWED = 'data_pass_viewed',
  PASS_IMPRESSION = 'data_pass_impression',
  MDT_SIGNUP = 'mdt_signup'
}

export enum EventComponent {
  OFFER = 'offer',
  DATA_PASS = 'data_pass',
  MDT_SIGNUP = 'mdt_signup'
}

export enum EventRole {
  MERCHANT = 'merchant',
  CUSTOMER = 'customer',
}
